
export const scannerConfigurationUrl = `${process.env.REACT_APP_BACKEND_URL}/api/v1/scanner/`;
export const ticketsUrl = `${process.env.REACT_APP_BACKEND_URL}/api/v1/scanner/tickets/`
export const scansUrl = `${process.env.REACT_APP_BACKEND_URL}/api/v1/scanner/tickets/scans/`;
export const revocationsUrl = `${process.env.REACT_APP_BACKEND_URL}/api/v1/scanner/tickets/revocations/`;
export const passesUrl = `${process.env.REACT_APP_BACKEND_URL}/api/v1/scanner/passes/`;
export const passScansUrl = `${process.env.REACT_APP_BACKEND_URL}/api/v1/scanner/passes/scans/`;
export const eventsUrl = `${process.env.REACT_APP_BACKEND_URL}/api/v1/events/`